<template>
  <div id="header">
    <component :is="currentComp"></component>
  </div>
</template>

<script>
import Def from "./Def";
import OldUnion from "./OldUnion";
// import NewUnion from "./NewUnion";
import NewUnion from './NewUnion2023/index.vue';
import { unionFlag } from "../../utils";
export default {
  components: {
    Def,
    OldUnion,
    NewUnion
  },
  data() {
    return {
      currentComp: null
    };
  },
  async created() {
    const union = unionFlag();

    if (union && union !== "stage") {
      const res = await this.apis.headerApi.getIsNewUnion();
      this.currentComp = res.body ? NewUnion : OldUnion;
      if (res.body) {
        document.getElementById("footer").style.display = "none";
        document.getElementById("wrapper-inner").style.paddingBottom = "50px";
      }
    } else {
      this.currentComp = Def;
    }
  }
};
</script>

<style lang="less" scoped>
#header {
  position: relative;
  z-index: 100;
}
</style>
